import { render, staticRenderFns } from "./PhSearch.vue?vue&type=template&id=30156260&scoped=true"
import script from "./PhSearch.vue?vue&type=script&lang=js"
export * from "./PhSearch.vue?vue&type=script&lang=js"
import style0 from "./PhSearch.vue?vue&type=style&index=0&id=30156260&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30156260",
  null
  
)

export default component.exports